import {
  skipToken,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  getApiV2CustomersCustomerIdTagGroupsTagGroupIdTags,
  type PaginatedCustomerTagListList,
} from '@hungryroot/rest/api/v2/customers/[id]/tag_groups/[tag_group_id]/tags/get';
import { type TagGroups } from '../tagGroups';

export const customerTagGroupKey = 'customer tag group';

function getQueryKey(tagGroupId?: TagGroups): (string | number)[] {
  return [customerTagGroupKey, Number(tagGroupId || 0)];
}

export function useCustomerTagGroup(
  tagGroupId?: TagGroups,
  options: Omit<
    UseQueryOptions<
      PaginatedCustomerTagListList,
      unknown,
      PaginatedCustomerTagListList,
      (number | string)[]
    >,
    'initialData' | 'queryFn' | 'queryKey'
  > = {}
) {
  return useQuery({
    queryKey: getQueryKey(tagGroupId),
    queryFn: tagGroupId
      ? async () => {
          const resp = await getApiV2CustomersCustomerIdTagGroupsTagGroupIdTags(
            {
              tagGroupId,
            }
          );

          if (resp.status !== StatusCode.SuccessOK) {
            throw new Error(JSON.stringify(resp.data, null, 2));
          }

          return resp.data;
        }
      : skipToken,
    ...options,
    enabled: options.enabled !== false,
  });
}
